<template>
  <footer class="content-footer" id="footer">
    <div class="content-footer-elements container">
      <div class="row w-100">
        <div class="col-lg-4 content-footer-elements-first">
          <div>
            <h3 class="d-none d-lg-block">Cafe da sorte</h3>
            <div class="content-footer-elements-contacts">
              <div class="content-footer-elements-logo d-lg-none">
                <img src="@/assets/img/footer/logos.png" alt="delta expresso">
              </div>
              <h3 class="d-lg-none">Cafe da sorte</h3>
              <div class="content-footer-elements-second-itens">
                <ul>
                  <li><router-link tag="a" to="/prizes">prémios</router-link></li>
                  <li><router-link tag="a" to="/account">a minha conta</router-link></li>
                  <li><router-link tag="a" to="/stores">estabelecimentos aderentes</router-link></li>
                </ul>
              </div>
            </div>
            <!-- <div class="content-footer-elements-contacts-phone">
              <svg xmlns="http://www.w3.org/2000/svg" width="21.057" height="21.057" viewBox="0 0 21.057 21.057">
                <path id="Path_163" data-name="Path 163" d="M4.847,55.929a.987.987,0,0,1-.962-.765L2.9,50.887a.987.987,0,0,1,.573-1.129l4.606-1.974a.987.987,0,0,1,1.153.282l2.04,2.493a15.255,15.255,0,0,0,7.29-7.29l-2.493-2.04a.987.987,0,0,1-.282-1.153l1.974-4.606a.987.987,0,0,1,1.129-.573l4.277.987a.987.987,0,0,1,.765.962A19.082,19.082,0,0,1,4.847,55.929Z" transform="translate(-2.873 -34.873)" fill="#00b373"/>
              </svg>
              <div class="content-footer-elements-contacts-phone-text">
                <p>(+351) 222 222 222</p>
                <span>seg. a sex (9h-18h)</span>
              </div>
            </div> -->
          </div>
          <!-- <div class="content-footer-elements-social">
            <div class="content-footer-elements-social-facebook">
              <svg xmlns="http://www.w3.org/2000/svg" width="28.956" height="28.956" viewBox="0 0 28.956 28.956">
                <path id="Path_166" data-name="Path 166" d="M25.854,32H3.1A3.1,3.1,0,0,0,0,35.1V57.854a3.1,3.1,0,0,0,3.1,3.1h8.871V51.112H7.9V46.478h4.072V42.946c0-4.017,2.391-6.236,6.054-6.236a24.669,24.669,0,0,1,3.589.313v3.943H19.6a2.317,2.317,0,0,0-2.613,2.5v3.009h4.446l-.711,4.634H16.983v9.844h8.871a3.1,3.1,0,0,0,3.1-3.1V35.1a3.1,3.1,0,0,0-3.1-3.1Z" transform="translate(0 -32)" fill="#fff"/>
              </svg>
            </div>
            <div class="content-footer-elements-social-instagram">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.198" height="29.201" viewBox="0 0 29.198 29.201">
                <path id="Exclusion_2" data-name="Exclusion 2" d="M27.113,29.2H2.077A2.094,2.094,0,0,1,0,27.1V2.105A2.094,2.094,0,0,1,2.077,0H27.113A2.1,2.1,0,0,1,29.2,2.105V27.1A2.1,2.1,0,0,1,27.113,29.2ZM10.577,4.8A5.786,5.786,0,0,0,4.8,10.577v7.317a5.784,5.784,0,0,0,5.781,5.776h7.317a5.782,5.782,0,0,0,5.777-5.776V10.577A5.784,5.784,0,0,0,17.894,4.8ZM17.894,22.26H10.577a4.37,4.37,0,0,1-4.366-4.365V10.577a4.37,4.37,0,0,1,4.366-4.363h7.317a4.368,4.368,0,0,1,4.363,4.363v7.317A4.369,4.369,0,0,1,17.894,22.26Zm-3.66-12.8a4.772,4.772,0,1,0,4.774,4.774A4.779,4.779,0,0,0,14.234,9.463ZM19.527,7.7A1.245,1.245,0,1,0,20.77,8.944,1.246,1.246,0,0,0,19.527,7.7Zm-5.294,9.864a3.326,3.326,0,1,1,3.327-3.324A3.33,3.33,0,0,1,14.234,17.562Z" fill="#fff"/>
              </svg>
            </div>
            <div class="content-footer-elements-social-youtube">
              <svg xmlns="http://www.w3.org/2000/svg" width="29.2" height="29.2" viewBox="0 0 29.2 29.2">
                <path id="Path_168" data-name="Path 168" d="M12.175,43.087l6.2,3.526-6.2,3.526ZM29.2,35.129V58.071A3.129,3.129,0,0,1,26.071,61.2H3.129A3.129,3.129,0,0,1,0,58.071V35.129A3.129,3.129,0,0,1,3.129,32H26.071A3.129,3.129,0,0,1,29.2,35.129ZM26.462,46.62a31.319,31.319,0,0,0-.5-5.749,2.975,2.975,0,0,0-2.1-2.112c-1.845-.5-9.268-.5-9.268-.5s-7.424,0-9.268.5a2.975,2.975,0,0,0-2.1,2.112,33.605,33.605,0,0,0,0,11.5,2.932,2.932,0,0,0,2.1,2.079c1.845.5,9.268.5,9.268.5s7.424,0,9.268-.5a2.932,2.932,0,0,0,2.1-2.079,31.223,31.223,0,0,0,.5-5.742Z" transform="translate(0 -32)" fill="#fff"/>
              </svg>
            </div>
          </div> -->
          <div class="content-footer-elements-logo d-none d-lg-block">
            <img src="@/assets/img/footer/logos.png" alt="delta expresso">
            <div class="content-footer-elements-copyrigth d-none d-lg-block mt-5">
              <p>© {{ (new Date().getFullYear()) }} Delta Cafés</p>
            </div>
          </div>
        </div>
        <div class="col-lg-8 d-flex justify-content-between flex-column" >
          <div class="row w-100">
            <div class="col-lg-6 content-footer-elements-second">
              <h3>consumidor</h3>
              <div class="content-footer-elements-second-itens">
                <ul>
                  <li><router-link tag="a" to="/faqs">perguntas frequentes</router-link></li>
                  <li>
                    <div class="content-footer-elements-form">
                      <router-link tag="a" to="/contact">Ajuda</router-link>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-lg-6 content-footer-elements-third">
              <h3>legal</h3>
              <div class="content-footer-elements-third-itens">
                <ul>
                  <li><a @click="goToPage('regulamento')">Regulamento</a></li>
                  <li><a @click="goToPage('termos-e-condicoes-web')">Termos de Utilização</a></li>
                  <li><a href="/storage/app/media/informacoeslegais/politicadeprivacidade.pdf" target="_blank" rel="noopener">Política de privacidade</a></li>
                  <li><a @click="goToPage('politica-de-cookies')">Política de cookies</a></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="content-footer-elements-politics">
            <div class="content-footer-elements-copyrigth d-lg-none">
              <p>© {{ (new Date().getFullYear()) }} Delta Cafés</p>
            </div>
          </div>
        </div>                
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
    }
  },
  methods: {
    goToPage(slug) {
        this.$router.push({ name: "LegalInformation", params: { slug: slug } });
        if (this.$route.name == "LegalInformation") {
            this.$router.go();
        }
    },
  }
  
}
</script>

<style lang="scss">
.content-footer{
  width: 100%;
  height: 563px;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 992px){
    height: auto;
  }
  &-elements{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    &-first{
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      height: 454px;
      padding: 20px;
      @media screen and (max-width: 992px){
        height: auto;
        margin: 60px 0;
        padding: 0 20px 0 40px;
      }
    }
    h3{
      color: var(--white);
      text-transform: uppercase;
      font-size: 24px;
      text-align: left;
    }
    &-contacts{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      gap: 40px;
      height: auto;
      &-phone{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 10px;
        &-text{
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          p{
            color: var(--white);
            margin-bottom: 0;
            font-size: 18px;
            line-height: 24px;
          }
          span{
            color: var(--white);
            opacity: 50%;
            font-size: 18px;
            line-height: 24px;
            font-family: 'Font Regular';
          }
        }
      }
    }
    &-email{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 10px;
      a{
        all: unset;
        cursor: pointer;
        color: var(--white);
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 0;
      }
    }
    &-form{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      a{
        all: unset;
        cursor: pointer;
        color: var(--white);
        font-size: 18px;
        line-height: 24px;
        margin-bottom: 0;
      }
    }
    &-social{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 15px;
    }
    &-logo{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      @media screen and (max-width: 992px) {
        margin-bottom: 30px;
      }
      img{
        width: 100%;
        height: auto;
      }
    }
    &-copyrigth{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      p{
        color: var(--white);
        font-size: 12px;
        line-height: 18px;
        margin-bottom: 0;
        text-align: left;
      }
    }
    &-second{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      height: 313px;
      padding: 20px 0 0 60px;
      border-left: 1px solid #858585;
      border-right: 1px solid #858585;
      @media screen and (max-width: 992px){
        border: none;
        border-top: 1px solid #858585;
        border-bottom: 1px solid #858585;
        height: auto;
        padding: 60px 0 60px 40px;
      }
      &-itens{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        ul{
          list-style: none;
          padding: 0;
          margin: 0;
          li{
            margin: 25px 0;
            text-align: start;
            a{
              color: var(--white) !important;
              font-family: 'Font Regular';
              font-size: 18px;
              line-height: 24px;
              text-decoration: none;
              text-transform: capitalize;
              cursor: pointer;
              &:hover{
                color: var(--white);
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    &-third{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      flex-direction: column;
      height: 313px;
      padding: 20px 0 0 60px;
      @media screen and (max-width: 992px){
        height: auto;
        padding: 60px 0 60px 40px;
        border-bottom: 1px solid #858585;
      }
      &-itens{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        ul{
          list-style: none;
          padding: 0;
          margin: 0;
          li{
            margin: 25px 0;
            text-align: start;
            a{
              color: var(--white) !important;
              font-family: 'Font Regular';
              font-size: 18px;
              line-height: 24px;
              text-decoration: none;
              text-transform: capitalize;
              cursor: pointer;
              &:hover{
                color: var(--white);
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
    &-politics{
      display: flex;
      justify-content: center;
      align-items: flex-start;
      gap: 66px;
      padding-bottom: 80px;
      @media screen and (max-width: 992px) {
        flex-direction: column;
        gap: 30px;
        padding: 60px 0 60px 40px;
      }
      div{
        a{
          all: unset;
          color: var(--white) !important;
          font-family: 'Font Regular';
          font-size: 18px;
          line-height: 24px;
          margin-bottom: 0;
          cursor: pointer;
        }
      }
    }
  }
}


</style>